import UserModalBase from './UserModalBase';
import CommonUserFields from './fields/CommonUserFields';
import EditUserInfoAlert from './EditUserInfoAlert';
import { validateEditUserForm } from '../../utils/userValidation';

const EditUserModal = ({ show, user, userTypes, onSubmit, onClose }) => {
  if (!user) return null;

  return (
    <UserModalBase
      show={show}
      title={`Edit User: ${user.displayName}`}
      initialValues={{
        username: user.username,
        displayName: user.displayName,
        emailAddress: user.emailAddress,
        agencyName: user.agencyName,
        userType: user.userType,
      }}
      validate={validateEditUserForm}
      submitLabel="Save Changes"
      loadingLabel="Saving..."
      onSubmit={form =>
        onSubmit({
          id: user.id,
          ...form,
          userType: Number(form.userType),
        })
      }
      onClose={onClose}
    >
      {({ formData, handleChange }) => (
        <>
          <CommonUserFields
            formData={formData}
            onChange={handleChange}
            userTypes={userTypes}
          />
          <EditUserInfoAlert />
        </>
      )}
    </UserModalBase>
  );
};

export default EditUserModal;